import { useState } from 'react';
import type { Zone } from '../types/zone';
import { getStoredZone, storeZone } from '../utils/storage';

export function useGrowingZone() {
  const [zone, setZone] = useState<Zone | null>(() => {
    return getStoredZone();
  });

  const updateZone = (newZone: Zone | null) => {
    setZone(newZone);
    storeZone(newZone);
  };

  return { zone, setZone: updateZone };
}